import { Component, EventEmitter, Input, OnInit, Output, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { DialogActionButtonModel } from '../../models/dialog-action-button.model';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { Observable } from 'rxjs';
import { ActionKeys } from '../../../Forms/enums/keys.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Constants: any = {
    ellipses: ' ...',
    maxNumberOfChars: 20,
};

export interface NewEntityDialogListItem {
    label: string;
    value: any;
    type: string;
    modifiedDate?: Date;
    createdDate?: Date;
}

export interface NewEntityDialogLocalizations {
    // Listed in order of appearance on the dialog
    header: string;
    description: string;
    entityName: string;
    newItemButton: string;
    or: string;
    itemListHeader: string;
    itemListDescription: string;
    itemListFilterPlaceholder: string;
    clone: string;
    create: string;
    cancel: string;
}

// The replacement of AmplifyDialog
@Component({
    selector: 'agpr-new-entity-dialog',
    templateUrl: './new-entity-dialog.component.html',
    styleUrls: ['./new-entity-dialog.component.scss'],
    standalone: false
})
export class NewEntityDialogComponent extends AbstractDialogComponent implements OnChanges, OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public itemsFetcher: Observable<NewEntityDialogListItem[]>;
    @Input() public width: number = 400;
    @Input() public minSearchStringSize: number = 3;
    @Input() public localizations: NewEntityDialogLocalizations;
    // Icon class to use in the header of the modal
    @Input() public iconClass: string = 'agpr-i-line-bullhorn';

    // @Input() public userOptions: DialogActionButtonModel[];


    /* eslint-disable @angular-eslint/no-output-on-prefix */
    @Output() public onClone: EventEmitter<any> = new EventEmitter();
    @Output() public onCancel: EventEmitter<any> = new EventEmitter();
    @Output() public onCreate: EventEmitter<any> = new EventEmitter();
    @Output() public onScroll: EventEmitter<any> = new EventEmitter();
    /* eslint-enable @angular-eslint/no-output-on-prefix */

    public isLoading: boolean = true;
    public isScrolled: boolean = false;
    public selectedType: any;

    public existingItems: NewEntityDialogListItem[];
    public filteredItems: NewEntityDialogListItem[];
    public selectedItem: any;
    public searchString: string = '';

    private filterTimeout;

    constructor(
        public configService: ConfigService,
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'NewEntity');
    }

    ngOnInit() {
        this.itemsFetcher.subscribe(items => {
            this.existingItems = items.sort((a, b) => {
                const dateA: Date = a.modifiedDate ? a.modifiedDate : a.createdDate;
                const dateB: Date = b.modifiedDate ? b.modifiedDate : b.createdDate;
                return dateB.getTime() - dateA.getTime();
            });
            this.filteredItems = this.existingItems.slice();
            this.isLoading = false;
        });
    }


    ngOnChanges() { }

    onCloneClick(): void {
        this.onClone.emit(this.selectedItem);
        this.closeDialog();
    }

    onCancelClick(): void {
        this.onCancel.emit();
        this.closeDialog();
    }

    onCloseClick(): void {
        this.closeDialog();
    }

    onCreateClick(): void {
        this.onCreate.emit();
        this.closeDialog();
    }

    onFilterTextChange(): void {
        // Disable short search strings but allow clearing
        if (this.searchString?.length < 3) {
            if (this.searchString.length === 0 && this.filteredItems.length !== this.existingItems.length) {
                this.filteredItems = this.existingItems.slice();
            }
            return;
        }

        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        this.filterTimeout = setTimeout(
            () => {
                this.filteredItems = this.existingItems.filter(item => item.label.toLocaleLowerCase().indexOf(this.searchString?.toLocaleLowerCase()) > -1);
            }, 300
        );
    }

    onRowSelect(item, event?: any): void {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }
        this.selectedItem = item;
    }

    // TODO : Add this back for the to-be-template-based big options at the top of the dialog
    /*
    optionSelected(event, optionIndex) {
    this.userOptions[optionIndex].click.emit();
    }*/
}
